module.exports = __webpack_public_path__ + "static/media/avatar-C_J.79b57d02.png";